<template>
  <el-card
    v-if="ready"
    class="inline-goal-card-minimal"
    body-style="padding: 0px">

    <div class="inline-goal-card-minimal__image" :style="background_image_css">

      <div class="inline-goal-card-minimal__section">
        <span>{{goal_meta.name}}</span>
      </div>

      <!--
      <inline-editable-text
        class="twolinetext mr-2"
        style="min-width: 100px;"
        @change="onUpdateGoalName"
        :value="goal_meta.name"
        :inline="true"
        :reset-on-update="false"
        :reset-on-cancel="false"
        :lost-focus-is-update="false"
        />
      -->

    </div>

  </el-card>
</template>

<script>
export default {
  props: {
    goal: { required: true }
  },
  data: () => ({
    deleting: false,
  }),
  computed: {
    ready() {
      /* This is required when we create goals after goals have been loaded */
      return this.$api.get_ready( 'goal:' + this.goal.$id )
    },
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goal.$id );
    },
    background_image_css() {
      return this.goal_meta.picture
              ? {
                backgroundImage: 'url(' + this.goal_meta.picture + ')',
                backgroundSize: 'cover'
              } : {}
    }
  },
  methods: {
    onUpdateGoalName( name ) {
      this.$api.goal_update_name({
        goal_id: this.goal.$id,
        name: name
      });
    },
  },
}
</script>

<style>
.inline-goal-card-minimal {
  width: 110px;
  height: 110px;
  float: left;
  margin: 0 4px 4px 0;
  cursor: pointer;
}
.inline-goal-card-minimal__image {
  filter: grayscale(33%);
  width: 100%;
  height: 130px;
  display: block;
  min-height: 100px;
  background-color: gray;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  /* Default image */
  background-size: contain;
  background-image: url('../../assets/goal_placeholder.png');
}
.inline-goal-card-minimal__section span {
  display: none;
}
.inline-goal-card-minimal__section {
  display: block;
  height: 100%;
  text-align: center;
}
.inling-goal-list:hover .inline-goal-card-minimal__section,
.inline-goal-card-minimal__section:hover {
  background-color: rgba(0, 0, 0, 0.3);
  text-decoration: none;
}
.inling-goal-list:hover .inline-goal-card-minimal__section > *,
.inline-goal-card-minimal__section:hover > * {
  font-size: 12pt;
  padding-top: 18px;
  color: white;
  display: inherit;
}
.inline-goal-card-minimal__section:hover {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
</style>
